import { closestHTMLElement } from "../../lib/dom.js";

export async function handleProfileClick(target, deps) {
  if (!(target instanceof HTMLElement)) {
    return false;
  }

  const customMuscleTriggerBtn = closestHTMLElement(target, ".custom-muscle-picker-trigger");
  if (customMuscleTriggerBtn) {
    deps.openCustomMusclePickerModal(customMuscleTriggerBtn.dataset.muscleTarget);
    return true;
  }

  if (target.classList.contains("custom-muscle-result-btn")) {
    deps.handleSelectCustomMuscle(target.dataset.muscleId);
    return true;
  }

  if (target.classList.contains("custom-muscle-chip-remove-btn")) {
    deps.handleRemoveCustomMuscle(target.dataset.muscleTarget, target.dataset.muscleId);
    return true;
  }

  if (
    target.id === "customMusclePickerCloseBtn" ||
    target.id === "customMusclePickerModal"
  ) {
    deps.closeCustomMusclePickerModal();
    return true;
  }

  if (target.id === "customMusclePickerClearBtn") {
    deps.clearCustomMuscleSelection(deps.getCustomMusclePickerTarget());
    return true;
  }

  if (target.id === "saveOneRMBtn") {
    await deps.handleSaveOneRM();
    return true;
  }

  if (target.id === "saveRestSettingsBtn") {
    await deps.handleSaveRestSupportSettings();
    return true;
  }

  if (target.id === "changePasswordBtn") {
    await deps.handleChangePassword();
    return true;
  }

  if (target.id === "createCustomExerciseBtn") {
    await deps.handleCreateCustomExercise();
    return true;
  }

  if (target.id === "logoutBtn") {
    await deps.unregisterAndroidDeviceTokenForCurrentUser();
    await deps.getAuth().signOut();
    return true;
  }

  if (target.id === "deleteAccountBtn") {
    await deps.handleDeleteAccount();
    return true;
  }

  return false;
}
